import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, Transition as _Transition, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11c9479e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sr-only" }
const _hoisted_2 = { class: "block sm:hidden" }
const _hoisted_3 = { class: "sm:block hidden" }
const _hoisted_4 = ["data-cy", "onClick"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MenuButton = _resolveComponent("MenuButton")!
  const _component_MenuItem = _resolveComponent("MenuItem")!
  const _component_MenuItems = _resolveComponent("MenuItems")!
  const _component_Menu = _resolveComponent("Menu")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.$store.state.availableLocales.length > 1)
      ? (_openBlock(), _createBlock(_component_Menu, {
          key: 0,
          as: "div",
          class: "ml-3 relative"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_MenuButton, {
                class: "flex text-opposite-500 text-sm rounded-full focus:outline-none",
                "data-cy": "language-button"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$t('header.openLanguageMenu')), 1),
                  _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.currentLanguage.shortName), 1),
                  _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.currentLanguage.longName), 1)
                ]),
                _: 1
              })
            ]),
            _createVNode(_Transition, {
              "enter-active-class": "transition ease-out duration-100",
              "enter-from-class": "transform opacity-0 scale-95",
              "enter-to-class": "transform opacity-100 scale-100",
              "leave-active-class": "transition ease-in duration-75",
              "leave-from-class": "transform opacity-100 scale-100",
              "leave-to-class": "transform opacity-0 scale-95"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_MenuItems, {
                  class: "profile-menu",
                  "data-cy": "languages-menu"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.availableLocales, (lang) => {
                      return (_openBlock(), _createBlock(_component_MenuItem, {
                        key: lang.code
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("a", {
                            "data-cy": 'language-' + lang.code,
                            onClick: ($event: any) => (_ctx.changeLanguage(lang.code)),
                            class: _normalizeClass([_ctx.$i18n.locale === lang.code ? 'text-primary-700' : '', 'block px-4 py-2 text-sm text-gray-700 cursor-pointer'])
                          }, _toDisplayString(lang.longName), 11, _hoisted_4)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _hoisted_5
  ], 64))
}